import React from 'react';
import { ClipLoader } from 'react-spinners';
import { useAppSelector } from '../store';

export default function GamesHeaderTitle(): React.ReactNode {
  const { games, loading } = useAppSelector((state) => state.gamesReducer);
  const page = useAppSelector((state) => state.paramsReducer.params.page) ?? 0;
  const pageSize = 20;

  if (loading) {
    return (
      <div className="cm-games-count">
        <ClipLoader color="#8a8f98" size={12} loading={loading} />
      </div>
    );
  }

  const count = games?.List?.length ?? 0;
  if (count == 0) {
    return null;
  }
  // The current page's range.
  const from = page * pageSize + 1;
  const to = page * pageSize + count;
  return (
    <div className="cm-games-count">
      {from}–{to} games
    </div>
  );
}
